import React, { Component } from "react";
import { Modal, Form, Input, Button, InputNumber } from "antd";
import { injectIntl } from "react-intl";
import "./index.styl";

class StubParamChargingModal extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            valueList: [],
        };
        // 计费规则form
        this.formRef = React.createRef();
    }

    handleOk = () => {
       // 校验参数
       const { validateFields } = this.formRef.current;
       validateFields().then((values) => {
        let appointStartTime = "";
        let appointEndTime = "";
        let appointEle = "";
        let appointTimeLen = "";
        const appointNum = `${this.state.valueList.length}`;
        this.state.valueList.forEach((item, index) => {
            appointStartTime = index === this.state.valueList.length - 1 ? appointStartTime + values[`appointStartTime${item}`] : `${appointStartTime + values[`appointStartTime${item}`]}|`;
            appointEndTime = index === this.state.valueList.length - 1 ? appointEndTime + values[`appointEndTime${item}`] : `${appointEndTime + values[`appointEndTime${item}`]}|`;
            appointEle = index === this.state.valueList.length - 1 ? appointEle + values[`appointEle${item}`] : `${appointEle + values[`appointEle${item}`]}|`;
            appointTimeLen = index === this.state.valueList.length - 1 ? appointTimeLen + values[`appointTimeLen${item}`] : `${appointTimeLen + values[`appointTimeLen${item}`]}|`;
        });
        const returnValue = {
          appointNum: appointNum,
          appointStartTime: appointStartTime,
          appointEndTime: appointEndTime,
          appointEle: appointEle,
          appointTimeLen: appointTimeLen,
        };
        this.props.okFunction(returnValue);
        this.setState({
            valueList: [0],
        });
       });
    }

    addForm = () => {
        const list = [...this.state.valueList, this.state.valueList.length];
        this.setState({
            valueList: list,
        });
    }

    delForm = (index) => {
        const values = this.formRef.current.getFieldsValue();
        delete values[`appointStartTime${index}`];
        delete values[`appointEndTime${index}`];
        delete values[`appointEle${index}`];
        delete values[`appointTimeLen${index}`];
        this.formRef.current.setFieldsValue(values);
        const list = [...this.state.valueList];
        list.splice(index, 1);
        this.setState({
            valueList: list,
        });
    }

    // 校验时间
    validatorTime = (_, value) => {
        const numTest = /[0-9]$/;
        if (value && value.length !== 4) {
            return Promise.reject(new Error("请输入4位数字"));
        } else if (value && !numTest.test(value)) {
            return Promise.reject(new Error("请输入数字"));
        }

        return Promise.resolve();
    }

    render() {
        if (this.state.valueList.length < 1) {
            this.setState({
                valueList: [0],
            });
        }
        return <Modal
          destroyOnClose
          visible={this.props.visible}
          title="预约充电修改"
          width={1000}
          onOk={this.handleOk}
          onCancel={() => {
              this.setState({ valueList: [0] });
              this.props.onCancel();
          }}>
            <div>
                <Form validateMessages={{ default: "" }} preserve={false} validateTrigger="onBlur" validateFirst ref={this.formRef}>
                    {
                        this.state.valueList.map((item, index) => <div className="price-form-group">
                              <Form.Item rules={[{ required: true, message: "请输入启动时间" }, { validator: this.validatorTime }]} name={`appointStartTime${item}`} label="预约启动时间">
                                  <Input style={{ width: 100 }}></Input>
                              </Form.Item>
                              <Form.Item rules={[{ required: true, message: "请输入结束时间" }, { validator: this.validatorTime }]} name={`appointEndTime${item}`} label="预约结束时间">
                                  <Input style={{ width: 100 }}></Input>
                              </Form.Item>
                              <Form.Item rules={[{ required: true, message: "请输入充电电量" }]} name={`appointEle${item}`} label="充电电量">
                                  <InputNumber
                                    min={0}
                                    style={{ width: 100 }} />
                              </Form.Item>
                              <Form.Item rules={[{ required: true, message: "请输入充电时长" }]} name={`appointTimeLen${item}`} label="充电时长">
                                  <InputNumber style={{ width: 100 }}></InputNumber>
                              </Form.Item>
                              {
                                  index === 0 ? <Button type="primary" onClick={this.addForm}>添加</Button> : <Button type="primary" onClick={() => { this.delForm(index); }}>删除</Button>
                              }
                                                                  </div>)
                    }
                </Form>
                <div style={{ color: "red" }}>注：预约启动时间、预约结束时间为4位数字，比如1330表示13点30分</div>
            </div>
               </Modal>;
    }
}

export default injectIntl(StubParamChargingModal);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubParamChargingModal.js